module.exports = __webpack_public_path__ + "static/img/05.23143ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/haeusle/05.jpg
// module id = 373
// module chunks = 1